<template>
    <div class="homeEmail">
    </div>
</template>

<script>
    export default {
        mounted:function(){//加载事件
            this.initData();//加载时触发数据填充
        },
        methods:{
            //下面是函数
            initData(){
                this.$http.get(`${window.context.portal}/runtime/instance/v1/getHaiyaEmailLogin`).then((resp) => {
                    window.open(resp.data.url);
                    this.$router.push({path: "/home",});
                });
            }
        }
    }
</script>